/* ==========================================================================
   HOMEPAGE HERO — THE MODELLE PRICE DROP
   Small controller for load state + scroll cue. No external dependencies.
   ========================================================================== */

(function () {
  'use strict';

  var HERO_SELECTOR = '[data-pd-hero]';
  var SCROLL_SELECTOR = '[data-pd-scroll]';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initHero(hero) {
    if (!hero || hero.dataset.pdReady === 'true') return;
    hero.dataset.pdReady = 'true';

    var image = hero.querySelector('.pd-hero__image');
    var reveal = function () {
      window.requestAnimationFrame(function () {
        hero.classList.add('is-loaded');
      });
    };

    if (prefersReducedMotion() || hero.dataset.pdAnimate !== 'true') {
      hero.classList.add('is-loaded');
    } else if (image && !image.complete) {
      image.addEventListener('load', reveal, { once: true });
      image.addEventListener('error', reveal, { once: true });
    } else {
      reveal();
    }

    var scrollButton = hero.querySelector(SCROLL_SELECTOR);
    if (scrollButton) {
      scrollButton.addEventListener('click', function () {
        var next = hero.closest('.shopify-section')
          ? hero.closest('.shopify-section').nextElementSibling
          : hero.parentElement && hero.parentElement.nextElementSibling;

        if (!next) return;

        var top = next.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      });
    }
  }

  function initAll() {
    document.querySelectorAll(HERO_SELECTOR).forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var hero = event.target.matches && event.target.matches(HERO_SELECTOR)
      ? event.target
      : event.target.querySelector(HERO_SELECTOR);
    initHero(hero);
  });
})();
